import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import * as Sentry from '@sentry/react';

const env = import.meta.env.VITE_FIREBASE_ENV;

// Parse the consolidated config based on environment
const getFirebaseConfig = () => {
  if (env === 'dev') {
    // In dev, use the dev config JSON
    return JSON.parse(import.meta.env.VITE_DEV_FIREBASE_CONFIG || '{}');
  } else {
    // In production, use the production config JSON
    return JSON.parse(import.meta.env.VITE_PUBLIC_FIREBASE_CONFIG || '{}');
  }
};

const firebaseVars = getFirebaseConfig();

// Always log Firebase environment for developer reassurance
// eslint-disable-next-line no-console
console.log(
  '🔒 [DATABASE]',
  env === 'dev' ? '🟡 DEVELOPMENT' : '🟢 PRODUCTION',
  '|',
  firebaseVars.projectId || 'unknown',
);

// Add environment-specific logging to Sentry (no sensitive data)
Sentry.addBreadcrumb({
  message: 'Firebase Environment Configuration',
  category: 'firebase-config',
  level: 'info',
  data: {
    environment: env === 'dev' ? 'DEVELOPMENT' : 'PRODUCTION',
  },
});

const firebaseConfig = {
  apiKey: firebaseVars.apiKey,
  // authDomain: firebaseVars.authDomain, // Temporarily removed to fix Clover SDK origin detection
  databaseURL: firebaseVars.databaseURL, // Corrected to match Firebase SDK expectation
  projectId: firebaseVars.projectId,
  storageBucket: firebaseVars.storageBucket,
  messagingSenderId: firebaseVars.messagingSenderId,
  appId: firebaseVars.appId,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);

export { app, auth, database };
